import React, { useMemo } from "react";
import { PieChart } from "../../ui/Graph";
import PropTypes from "prop-types";
const PieChartSmsDashboard = ({ data, loading }) => {
  const createArr = useMemo(() => {
    const arr = [];
    arr.push(Number(data?.i_api));
    arr.push(Number(data?.i_campaigns));
    return arr;
  }, [data]);

  return (
    <PieChart
      title="Distribución de SMS por tipo de envío"
      labels={["API", "Campañas"]}
      dataSets={createArr}
      label="No. de SMS"
      loading={loading}
    />
  );
};

PieChartSmsDashboard.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
};

export default PieChartSmsDashboard;
